module.exports = __webpack_public_path__ + "27d379276b34731d22ebfe07cff707fd.obj";